module.exports = __webpack_public_path__ + "media/1_4.1926b0c8.wav";